import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { UpdateTransactionStatusComponent } from './update-transaction-status/update-transaction-status.component';
import { UpdateProfileWizardComponent } from './update-profile-wizard/update-profile-wizard.component';
import { TestProfileWizardComponent } from './test-profile-wizard/test-profile-wizard.component';
import { RuleHistoryDialogComponent } from './rule-history-dialog/rule-history-dialog.component';
import { Pipe } from '@angular/core/';
import { PipeTransform } from '@angular/core/';
import { EntityTransactionMonitoringService } from './entity-transaction-monitoring.service';
import { NgModule, Injectable } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { EntityTransactionMonitoringComponent } from 'app/entities/transaction-monitoring/entity-transaction-monitoring.component';
import {Ng2PaginationModule} from 'ng2-pagination';
import { SharedModule } from 'app/shared/shared.module';
import { EntityFinanceModule } from 'app/entities/finance/entity-finance.module';
import { EntityTransactionProfileModule } from 'app/entities/transaction-profile/entity-transaction-profile.module';
import { GenericSearchService } from 'app/shared/components/genericsearch/generic-search.service';
import { EntityRelationsService } from 'app/entities/relations/entity-relations.service';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';


@Pipe({
    name: 'searchfilter'
})

@Injectable()
export class SearchFilterPipe implements PipeTransform {
    transform(items: any[], field: string, value: string): any[] {
        if (value == 'all') return items;
        if (!items) return [];
        return items.filter(it => it[field] == value);
    }
}

@NgModule({
    declarations: [
        EntityTransactionMonitoringComponent,
        UpdateTransactionStatusComponent,
        UpdateProfileWizardComponent,
        TestProfileWizardComponent,
        RuleHistoryDialogComponent,
        SearchFilterPipe
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        InfiniteScrollModule,
        Ng2PaginationModule,
        SharedModule,
        EntityFinanceModule,
        EntityTransactionProfileModule
    ],
    providers: [
        EntityTransactionMonitoringService,
        GenericSearchService,
        EntityRelationsService,
        EntityTransactionProfileService
    ],
    entryComponents: [
        UpdateTransactionStatusComponent,
        UpdateProfileWizardComponent,
        TestProfileWizardComponent,
        RuleHistoryDialogComponent
    ],
    exports: [

    ]
})

export class EntityTransactionMonitoringModule { }



// WEBPACK FOOTER //
// ./src/app/entities/transaction-monitoring/entity-transaction-monitoring.module.ts